{
  "shared": {
    "filter": {
      "title": "التصفية",
      "applied": "المطبّق:",
      "more": "مزيد من عوامل التصفية",
      "show": "عرض النتائج",
      "showCount": "عرض النتائج: {{count}}",
      "notAvailable": "غير متاح لك",
      "emptyFilteredHint": "غيّر عوامل التصفية أو امسحها لعرض المزيد.",
      "dateRange": {
        "from": "من",
        "to": "إلى",
        "toBeforeFrom": "تاريخ النهاية يسبق تاريخ البداية."
      }
    }
  }
}
